import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ClientPluginNotesModal = (props) => {
    const { isOpen, noteText, closeModal } = props;

    return (
        <Modal isOpen={isOpen} centered className="text-light">
            <ModalHeader>Plugin Notes:</ModalHeader>
            <ModalBody>{noteText}</ModalBody>
            <ModalFooter>
                <Button color="light" onClick={() => closeModal()}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ClientPluginNotesModal;
